import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { TRANSLATIONS } from "@/lib/translations";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

const get = (obj, path) =>
  path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("rkjain_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("rkjain_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let val = get(TRANSLATIONS[lang], key);
      if (val == null) val = get(TRANSLATIONS.en, key);
      if (val == null) return key;
      if (typeof val === "string" && vars) {
        Object.keys(vars).forEach((k) => {
          val = val.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
